<template>
<m-pageframe
    title="TCR Campaigns"
>
<v-container
    fluid
    style="padding-left: 15px; padding-right: 15px"
>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>

            <v-list>
                <v-list-item
                    v-on:click="doUpdate()"
                >
                    <v-list-item-title>Refresh</v-list-item-title>
                </v-list-item>
            </v-list>

            <v-divider/>
    
            <v-list>
                <v-list-item
                    v-on:click="onClickTCRSync()"
                >
                    <v-list-item-title>Sync with TCR...</v-list-item-title>
                </v-list-item>
            </v-list>

            <v-divider/>

             <v-list>
                <v-list-item
                    v-on:click="onClickExport()"
                >
                    <v-list-item-title>Export...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> 
    </v-text-field>

    <v-layout row wrap>
        <v-flex flex-grow-0>

            <m-boolean-search-filter
                style="margin-top: 5px; margin-left: 10px;"
                label="AT&T"
                v-model="filter_att"
                v-on:input='doUpdate'
            />
        </v-flex>

        <v-flex flex-grow-0>
            <m-boolean-search-filter
                style="margin-top: 5px; margin-left: 10px;"
                label="T-Mobile"
                v-model="filter_t_mobile"
                v-on:input='doUpdate'
            />
        </v-flex>

        <v-flex flex-grow-0>
            <m-boolean-search-filter
                style="margin-top: 5px; margin-left: 10px;"
                label="Verizon"
                v-model="filter_verizon"
                v-on:input='doUpdate'
            />
        </v-flex>
    </v-layout>
    
    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="1000"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.time_created_date="{ item }">
            {{$rc.pretty(item.time_created,'date')}}
        </template>

        <template v-slot:item.elected_dca_att="{ item }">
            <v-simple-checkbox v-ripple="false" v-model="item.elected_dca_att" disabled></v-simple-checkbox>
        </template>

        <template v-slot:item.elected_dca_t_mobile="{ item }">
            <v-simple-checkbox v-ripple="false" v-model="item.elected_dca_t_mobile" disabled></v-simple-checkbox>
        </template>

        <template v-slot:item.elected_dca_verizon="{ item }">
            <v-simple-checkbox v-ripple="false" v-model="item.elected_dca_verizon" disabled></v-simple-checkbox>
        </template>

        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical-circle-outline
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickTechnicalDetails(item)"
                >
                    <v-list-item-title>Technical Details...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>

    
    </v-data-table>



</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            full_text: null,
            results: [],
            headers: [
                { text: 'Date', value: 'time_created_date'},
                { text: 'Brand Id', value: 'brand_id'}, 
                { text: 'Brand Display Name', value: 'brand_display_name'},
                { text: 'Brand Company Name', value: 'brand_company_name'},
                { text: 'Organization Label', value: 'organization_label'},
                { text: '# Orgs', value: 'count_organizations_utilizing'},

                
                { text: 'Campaign Id', value: 'campaign_id'}, 
                { text: 'Status', value: 'status'},
                { text: 'Network', value: 'comm_network'},

                { text: 'AT&T', value: 'elected_dca_att'},
                { text: 'T-Mobile', value: 'elected_dca_t_mobile'},
                { text: 'Verizon', value: 'elected_dca_verizon'},
                { text: 'Action', value: 'action'},
            ],

            filter_att: null,
            filter_t_mobile: null,
            filter_verizon: null,
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {

        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/tcr/campaigns',
            
                'params' : {
                        'full_text': this.full_text,
                        'sort': 'time_created:desc',
                        'elected_dca_att': this.filter_att,
                        'elected_dca_t_mobile': this.filter_t_mobile,
                        'elected_dca_verizon': this.filter_verizon,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to list campaigns',
            });
        },
        

        onClickTCRSync() {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/admin/tasks/run',
            
                'params' : {
                        'id': 'PROCESSOR_TCR_SYNC',
                    },
            
                'on_success': (data) => {
                        this.$rc.snackbar('TCR Sync Started.  This will take several minutes to complete.');
                    },
            
                'on_error': 'Unable to start sync with TCR',
            });
        },

        onClickTechnicalDetails(item)
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'GET: /api/v1/tcr/campaign-technical-details/:campaign_id',
            
                'params' : {
                        'campaign_id': item.campaign_id,
                    },
            
                'on_success': (data) => {
                        this.$rc.copy_code_dialog({
                            'title': 'Campaign Technical Details',
                            'object': data,
                        });
                    },
            
                'on_error': 'Unable to get technical details',
            });

             
        },

        onClickExport()
        {
            this.$rc.excelExport(
                    'EXPORT: /api/v1/tcr/excel-export',
                    {
                    }
                );
        },
    },
}
</script>

<style lang="scss" scoped>
</style>